import { lazyDocLinkHadPreviewInfo } from 'owa-doc-link-click-handler';
import { isFeatureEnabled } from 'owa-feature-flags';

export async function prefetchGetWACInfo(url: string) {
    // call lazyDocLinkHadPreviewInfo and it will prefetch getWacInfo
    // so the context menu can determine to show preview menu item or not earlier
    if (isFeatureEnabled('doc-SxS-jsApi-ODB-Links')) {
        const docLinkHadPreviewInfo = await lazyDocLinkHadPreviewInfo.import();
        docLinkHadPreviewInfo(url);
    }
}
